import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { adminAuthAPI } from '../../services/adminAPI';
import './admin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    console.log('Admin login attempt with:', formData.username);

    try {
      const response = await adminAuthAPI.login(formData);
      
      console.log('Login response:', response);
      console.log('Response data:', response.data);
      
      localStorage.setItem('admin_access_token', response.data.access_token);
      localStorage.setItem('admin_refresh_token', response.data.refresh_token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.admin));

      console.log('Tokens stored, redirecting to dashboard...');
      
      // Dispatch custom event to trigger App.js re-render
      window.dispatchEvent(new Event('authChange'));
      
      // Small delay to ensure state updates, then navigate
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 100);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <FontAwesomeIcon icon={faShieldAlt} />
          <h1>Super Admin</h1>
          <p>BestieConnect Administration Panel</p>
        </div>

        {error && (
          <div className="admin-error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter your username"
            />
          </div>

          <div className="admin-form-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <label htmlFor="password">Password</label>
              <Link 
                to="/admin/forgot-password" 
                style={{ 
                  color: '#4CAF50', 
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500'
                }}
              >
                Forgot Password?
              </Link>
            </div>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className="admin-btn" disabled={loading}>
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin />
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
